var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"MLoginButtonTrigger"},[(!_vm.authenticated)?_c('b-button',{staticClass:"is-primary",class:_vm.classes,on:{"click":_vm.loginButtonClick}},[_vm._v(" "+_vm._s(_vm.$t('dict.loginOrSignup'))+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }